<!-- filepath: /workspaces/books/src/components/TermsContent.vue -->
<template>
  <div class="terms-content-overlay" @click.self="$emit('close')">
    <div class="terms-content-container">
      <div class="terms-content-header">
        <h2>ブックマーク管理サービス 利用規約</h2>
        <button class="close-button" @click="$emit('close')">×</button>
      </div>
      
      <div class="terms-content-body">
        <p>本利用規約（以下「本規約」）は、本サービスを提供する運営者（以下「当方」）が提供するブックマーク管理サービス（以下「本サービス」）の利用に関する条件を定めるものです。本サービスを利用される皆さま（以下「ユーザー」）は、本規約に同意いただいたうえで本サービスをご利用ください。</p>

        <h3>第1条（本サービスの内容）</h3>
        <ol>
          <li>本サービスは、ウェブ上でブックマークをタイル状に管理する機能を提供するものです。ユーザーは登録フォームやドラッグ&ドロップ等のUIを通じてブックマークを追加・編集し、Cookieおよびローカルストレージを用いてデータを保存します。</li>
          <li>本サービスではデータベースを使用せず、ユーザーのブラウザ環境で動作するため、ユーザーはインターネット接続および対応ブラウザ等を準備する必要があります。</li>
          <li>本サービスは、広告エリアや検索機能、JSON形式でのエクスポート・インポート機能などを備えています。詳細な仕様は別途定義された要件定義書等をご確認ください。</li>
        </ol>

        <h3>第2条（規約への同意）</h3>
        <ol start="4">
          <li>ユーザーは、本サービスを利用することによって、本規約の内容に同意したものとみなします。</li>
          <li>ユーザーが未成年の場合、法定代理人の同意を得たうえで本サービスを利用してください。</li>
        </ol>

        <h3>第3条（規約の変更）</h3>
        <ol start="6">
          <li>当方は、必要に応じて本規約を変更することができます。変更後の規約は、本サービス上または当方が適当と判断する方法で告知された時点から効力を生じるものとします。</li>
          <li>本規約の変更後にユーザーが本サービスを利用した場合、変更後の規約に同意したものとみなします。</li>
        </ol>

        <h3>第4条（アカウント・データ管理）</h3>
        <ol start="8">
          <li>本サービスでは、Cookieおよびローカルストレージを用いてブックマークやユーザー設定などのデータ（以下「ユーザーデータ」）を保存します。</li>
          <li>ユーザーデータのバックアップやエクスポート・インポートはユーザー自身の責任において行ってください。</li>
          <li>ブラウザの設定変更やCookie削除などにより、ユーザーデータが失われる可能性がありますが、当方はこれに関して一切の責任を負いません。</li>
        </ol>

        <h3>第5条（禁止事項）</h3>
        <p>ユーザーは、本サービスの利用にあたり、以下の行為をしてはならないものとします。</p>
        <ol start="11">
          <li>法令または公序良俗に違反する行為</li>
          <li>犯罪行為や違法行為に結びつくおそれのある行為</li>
          <li>第三者もしくは当方の権利・利益を侵害する行為（著作権、商標権、プライバシー等）</li>
          <li>他のユーザーや第三者に不利益または損害を与える行為</li>
          <li>本サービスの運営を妨害したり、システムやサーバに過度な負荷をかける行為</li>
          <li>本サービスの趣旨・目的から逸脱した方法での利用</li>
          <li>その他、当方が不適切と判断する行為</li>
        </ol>

        <h3>第6条（権利帰属）</h3>
        <ol start="18">
          <li>本サービスに関する著作権、商標権、その他の知的財産権は、当方または正当な権利を有する第三者に帰属します。</li>
          <li>本サービスを通じて提供されるコンテンツの著作権は、当方または正当な権利を有する第三者に帰属します。ユーザーは、本規約で明示的に認められた範囲を超えて、複製、改変、譲渡、貸与、翻案、その他の行為を行ってはならないものとします。</li>
        </ol>

        <h3>第7条（免責事項）</h3>
        <ol start="20">
          <li>当方は、本サービスの内容やユーザーデータの完全性・正確性・有用性・安全性等について、いかなる保証も行いません。</li>
          <li>本サービスの提供にあたり、通信回線やシステム障害、ブラウザのバージョンや設定などに起因して発生した損害やユーザーデータの消失等について、当方は一切の責任を負わないものとします。</li>
          <li>本サービスに掲載される広告やリンク先の外部サイトの利用に関して生じたいかなる損害についても、当方は責任を負いません。</li>
          <li>本サービスは予告なく内容の変更、追加、停止、終了を行うことがあり、これによりユーザーまたは第三者に生じた損害についても、当方は一切の責任を負いません。</li>
        </ol>

        <h3>第8条（サービスの変更・中断・終了）</h3>
        <ol start="24">
          <li>当方は、定期的または緊急にシステム保守やアップデート等を行う場合、本サービスの全部または一部を変更・中断・終了することがあります。</li>
          <li>当方は、前項に定める変更・中断・終了に起因してユーザーに損害が生じた場合であっても、一切の責任を負いません。</li>
        </ol>

        <h3>第9条（個人情報の取り扱い）</h3>
        <ol start="26">
          <li>本サービスがCookieやローカルストレージに保存するデータには、ユーザーが入力したブックマーク情報等が含まれますが、個人情報を取得するかどうかはユーザーの入力次第となります。</li>
          <li>本サービスにおいてユーザーが任意に個人情報を登録した場合、その取り扱いについては別途定めるプライバシーポリシー等がある場合はそちらを優先して適用します。</li>
        </ol>

        <h3>第10条（利用停止・登録削除）</h3>
        <p>ユーザーが本規約に違反した場合、当方は当該ユーザーによる本サービスの利用を一時停止し、または本サービス上のデータを削除する等の措置をとることができるものとします。</p>

        <h3>第11条（準拠法および管轄裁判所）</h3>
        <ol start="28">
          <li>本規約の解釈および適用にあたっては、日本法を準拠法とします。</li>
          <li>本サービスに関連して紛争が生じた場合、当方の所在地を管轄する裁判所を専属管轄裁判所とします。</li>
        </ol>

        <h3>第12条（協議事項）</h3>
        <p>本規約に定めのない事項や、解釈に疑義が生じた場合には、ユーザーと当方との間で誠意をもって協議し、解決を図るものとします。</p>
      </div>
      
      <div class="terms-content-buttons">
        <button class="close-button-bottom" @click="$emit('close')">閉じる</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsContent'
}
</script>

<style scoped>
.terms-content-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1200; /* TermsModalより上に表示 */
}

.terms-content-container {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.terms-content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.terms-content-header h2 {
  margin: 0;
  font-size: 1.3rem;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #999;
}

.close-button:hover {
  color: #333;
}

.terms-content-body {
  padding: 20px;
  overflow-y: auto;
  flex-grow: 1;
}

.terms-content-body h3 {
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  color: #333;
}

.terms-content-body p {
  margin-bottom: 1em;
  line-height: 1.6;
}

.terms-content-body ol {
  padding-left: 1.5em;
  margin-bottom: 1em;
}

.terms-content-body li {
  margin-bottom: 0.5em;
}

.terms-content-buttons {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  text-align: center;
}

.close-button-bottom {
  background-color: #e9d0ca;
  color: #333;
  border: none;
  border-radius: 4px;
  padding: 8px 25px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.close-button-bottom:hover {
  background-color: #d9b6ab;
}
</style>